import { lazy } from "react";

const Products = lazy(() =>
  import("../Catalog/Product/ProductList/Products")
);
const AddEditProd = lazy(() =>
  import("../Catalog/Product/Form/AddEditProd")
);
const ImportCatalog = lazy(() =>
  import("../Catalog/Product/ImportCatalog/ImportCatalog")
);
const Categories = lazy(() => import("../Catalog/Category/Categories"));
const Suppliers = lazy(() => import("../Catalog/Supplier/Suppliers"));
const AddEditSplr = lazy(() => import("../Catalog/Supplier/AddEditSplr"));
const ViewSupplier = lazy(() =>
  import("../Catalog/Supplier/ViewSupplier/ViewSupplier")
);
const ImportSupplier = lazy(() =>
  import("../Catalog/Supplier/ImportSupplier/ImportSupplier")
);
const Brands = lazy(() => import("../Catalog/Brand/Brands"));
const Tags = lazy(() => import("../Catalog/Tag/Tags"));
const ProdAttrs = lazy(() => import("../Catalog/ProdAttr/ProdAttrs"));
const PriceCategories = lazy(() => import("../Catalog/PriceCategory/PriceCategories"));
const UnitManagement = lazy(() => import("../Catalog/UnitManagement/UnitManagement"));
const Services = lazy(() => import("../Catalog/Service/ServiceList/Services"));
const AddEditService = lazy(() => import("../Catalog/Service/Form/AddEditService"));
const ServiceCategories = lazy(() => import("../Catalog/ServiceCategory/ServiceCategories"));

// ---- Promotion engine ----
const Coupons = lazy(() => import("../Catalog/Promotions/Coupons/Coupons"));

export const catalogRoutes = (access, settings) => {
  if (!settings?.fiscalYearId) return [];

  const routes = [];

  if (access.catalogAccess) {
    if (access.catalog?.import) {
      routes.push({ path: "/import_catalog", element: ImportCatalog, title: "importCatalog" });
    }
    routes.push(
      { path: "/products", element: Products, title: "products" },
      { path: "/product_form", element: AddEditProd, title: "addProduct", enabled: access.catalog?.create },
      { path: "/product_form/:id", element: AddEditProd, title: "editProduct", enabled: access.catalog?.edit },
    );
  }

  if (access.supplierAccess) {
    routes.push(
      { path: "/suppliers", element: Suppliers, title: "suppliers" },
      { path: "/view_supplier/:supplierId", element: ViewSupplier, title: "viewSupplier" },
      { path: "/supplier_form", element: AddEditSplr, title: "addSupplier", enabled: access.supplier?.create },
      { path: "/supplier_form/:id", element: AddEditSplr, title: "editSupplier", enabled: access.supplier?.edit },
      { path: "/import_suppliers", element: ImportSupplier, title: "importSuppliers", enabled: access.supplier?.create },
    );
  }

  if (access?.brandAccess) routes.push({ path: "/brands", element: Brands, title: "brands" });
  if (access?.couponAccess) routes.push({ path: "/coupons", element: Coupons, title: "coupons" });
  if (access?.productAttributeAccess) routes.push({ path: "/product_attributes", element: ProdAttrs, title: "productAttributes" });
  if (access?.tagAccess) routes.push({ path: "/tags", element: Tags, title: "tags" });
  if (access?.categoryAccess) routes.push({ path: "/product_category", element: Categories, title: "productCategories" });
  if (access?.catalogAccess) routes.push({ path: "/price_categories", element: PriceCategories, title: "priceCategories" });
  if (access?.catalogAccess) routes.push({ path: "/unit_management", element: UnitManagement, title: "unitManagement" });

  // Services. Gated on the access flag alone — the per-company "Enable Services"
  // switch was removed 2026-08-02; it duplicated this permission and won the tie.
  if (access?.serviceAccess) {
    routes.push(
      { path: "/services", element: Services, title: "services" },
      { path: "/service_form", element: AddEditService, title: "addService", enabled: access.serviceAccessNav?.create },
      { path: "/service_form/:id", element: AddEditService, title: "editService", enabled: access.serviceAccessNav?.edit },
    );
  }
  if (access?.serviceCategoryAccess) {
    routes.push({ path: "/service_categories", element: ServiceCategories, title: "serviceCategories" });
  }

  return routes;
};
